import React from 'react';

// Accent palettes for the CRM quick-stat cards (Fires, Questions). Each maps
// to an icon chip + value colour on the standard white/gray-900 card surface.
const TONES = {
  red: { chip: 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-400', value: 'text-red-600 dark:text-red-400' },
  orange: { chip: 'bg-orange-100 text-orange-600 dark:bg-orange-900/40 dark:text-orange-400', value: 'text-orange-600 dark:text-orange-400' },
  yellow: { chip: 'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/40 dark:text-yellow-400', value: 'text-yellow-600 dark:text-yellow-400' },
  blue: { chip: 'bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400', value: 'text-blue-600 dark:text-blue-400' },
  green: { chip: 'bg-green-100 text-green-600 dark:bg-green-900/40 dark:text-green-400', value: 'text-green-600 dark:text-green-400' },
  purple: { chip: 'bg-purple-100 text-purple-600 dark:bg-purple-900/40 dark:text-purple-400', value: 'text-purple-600 dark:text-purple-400' },
  gray: { chip: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300', value: 'text-gray-900 dark:text-white' },
};

/**
 * Quick-stat tile matching the Leads / Clients / Tasks card language:
 * white (gray-900 dark) surface, hairline border, rounded-2xl, soft shadow.
 * Everything is centred to match the portal design language. `hint` adds an
 * optional caption under the value.
 */
const CrmStatCard = ({ icon: Icon, label, value, hint, tone = 'gray', compact = false, onClick, active = false }) => {
  const t = TONES[tone] || TONES.gray;
  const Wrapper = onClick ? 'button' : 'div';
  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`flex flex-col items-center justify-center text-center rounded-2xl border bg-white dark:bg-gray-900 shadow-sm transition-all ${
        compact ? 'p-3 gap-1.5' : 'p-4 gap-2'
      } ${
        active
          ? 'border-red-300 dark:border-red-700 ring-2 ring-red-500/20'
          : 'border-gray-200 dark:border-gray-800'
      } ${onClick ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5' : ''}`}
    >
      {Icon && (
        <span className={`inline-flex items-center justify-center rounded-full ${compact ? 'w-9 h-9' : 'w-11 h-11'} ${t.chip}`}>
          <Icon className={compact ? 'w-4 h-4' : 'w-5 h-5'} />
        </span>
      )}
      <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">{label}</span>
      <span className={`${compact ? 'text-xl' : 'text-3xl'} font-bold tracking-tight leading-none ${t.value}`}>{value}</span>
      {hint && <span className="text-xs leading-snug text-gray-500 dark:text-gray-400">{hint}</span>}
    </Wrapper>
  );
};

export default CrmStatCard;
